import { I18nProvider, useI18n } from '@/i18n/I18nProvider';
import { Helmet } from 'react-helmet-async';
import { useSearchParams } from 'react-router-dom';

const PrivacyComponent = () => {
  const { t, locale } = useI18n();

  const renderPurposesTable = () => {
    if (!t.privacy.purposesTable) return null;

    const headers = {
      es: ['Finalidad', 'Base jurídica', 'Conservación'],
      en: ['Purpose', 'Legal basis', 'Retention']
    };
    
    const currentHeaders = headers[locale] || headers.en;

    return (
      <table className='w-full my-4 border text-sm'>
        <thead>
          <tr className='bg-gray-100'>
            <th className='border px-2 py-1 text-left'>{currentHeaders[0]}</th>
            <th className='border px-2 py-1 text-left'>{currentHeaders[1]}</th>
            <th className='border px-2 py-1 text-left'>{currentHeaders[2]}</th>
          </tr>
        </thead>
        <tbody>
          {t.privacy.purposesTable.map((row, i) => (
            <tr key={i}>
              <td className='border px-2 py-1'>{row.purpose}</td>
              <td className='border px-2 py-1 text-left'>{row.legal}</td>
              <td className='border px-2 py-1 text-left'>{row.retention}</td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  };

  return (
    <>
      <Helmet>
        <title>{t.privacy.title}</title>
        <meta name='description' content={t.privacy.title + ' - ' + t.privacy.lastUpdate} />
        <html lang={locale} />
        <link rel='canonical' href={`/privacy?lang=${locale}`} />
      </Helmet>
      <div className='min-h-screen flex flex-col'>
        <main className='flex-grow container mx-auto px-4 py-8 max-w-2xl'>
          <h1 className='text-3xl font-bold mb-2'>{t.privacy.title}</h1>
          <div className='text-sm text-gray-500 mb-6'>{t.privacy.lastUpdate}</div>

          <h2 className='text-xl font-semibold mt-6 mb-2'>{t.privacy.responsibleTitle}</h2>
          <p className='mb-4' dangerouslySetInnerHTML={{__html: t.privacy.responsible}} />

          <h2 className='text-xl font-semibold mt-6 mb-2'>{t.privacy.dataTitle}</h2>
          <p className='mb-4' style={{whiteSpace: 'pre-line'}}>{t.privacy.data}</p>

          <h2 className='text-xl font-semibold mt-6 mb-2'>{t.privacy.purposesTitle}</h2>
          {renderPurposesTable()}

          <h2 className='text-xl font-semibold mt-6 mb-2'>{t.privacy.cookiesTitle}</h2>
          <p className='mb-4' style={{whiteSpace: 'pre-line'}}>{t.privacy.cookies}</p>

          <h2 className='text-xl font-semibold mt-6 mb-2'>{t.privacy.recipientsTitle}</h2>
          <p className='mb-4' style={{whiteSpace: 'pre-line'}}>{t.privacy.recipients}</p>

          <h2 className='text-xl font-semibold mt-6 mb-2'>{t.privacy.rightsTitle}</h2>
          <p className='mb-4' style={{whiteSpace: 'pre-line'}}>{t.privacy.rights}</p>

          <h2 className='text-xl font-semibold mt-6 mb-2'>{t.privacy.securityTitle}</h2>
          <p className='mb-4'>{t.privacy.security}</p>

          <h2 className='text-xl font-semibold mt-6 mb-2'>{t.privacy.changesTitle}</h2>
          <p className='mb-4'>{t.privacy.changes}</p>

          <div className='mt-8 text-sm text-gray-500'>{t.privacy.entity}</div>
        </main>
      </div>
    </>
  );
};

const PrivacyPage = () => {
  const [searchParams] = useSearchParams();
  const lang = searchParams.get('lang');
  const locale = lang === 'en' ? 'en' : 'es';

  return (
    <I18nProvider initialLocale={locale} key={locale}>
      <PrivacyComponent />
    </I18nProvider>
  );
};

export default PrivacyPage; 